import { useProject } from '@/modules/projects/hooks/project'
import type { PortfolioOverview } from '../model/portfolioOverview'
import type { MonthKey } from '../model/types'
import type { PortfolioAccount } from '../types'
import { UnvestedAwards } from '../UnvestedAwards'
import { YearToDate } from '../YearToDate'
import { AccountCard } from './AccountCard'
import { DetailTabs } from './DetailTabs'
import { detailScopeFor } from './detailScope'
import { useDetailAccounts } from './useDetailAccounts'

export interface PortfolioDetailProps {
  overview: PortfolioOverview
  month: MonthKey
  selectedAccountId: string | null
}

interface PortfolioDetailViewProps extends PortfolioDetailProps {
  // The statements folded per account, for holdings, awards, year to date and realized gains.
  accounts: PortfolioAccount[]
  slug: string
}

// The lower half for the "Showing" choice: the account card, awards and year to date above the tabs.
export const PortfolioDetailView = ({
  overview,
  month,
  selectedAccountId,
  accounts,
  slug,
}: PortfolioDetailViewProps) => {
  const scope = detailScopeFor(overview, accounts, month, selectedAccountId)
  const showNames = scope.chosen == null
  return (
    <div className="flex flex-col gap-4">
      {scope.chosen && (
        <AccountCard
          section={scope.chosen}
          overview={overview}
          asOfDate={scope.asOfDate}
        />
      )}
      <UnvestedAwards sections={scope.sections} showNames={showNames} />
      <YearToDate
        sections={scope.sections}
        showNames={showNames}
        year={scope.month.slice(0, 4)}
      />
      <div className="mt-2">
        <DetailTabs scope={scope} overview={overview} slug={slug} />
      </div>
    </div>
  )
}

export const PortfolioDetail = (props: PortfolioDetailProps) => {
  const accounts = useDetailAccounts()
  const slug = useProject()?.slug ?? 'portfolio'
  return <PortfolioDetailView {...props} accounts={accounts} slug={slug} />
}
